//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUrlParam, goNewHTML } from "../lib/routerUtil";
export default {
  data() {
    return {
      erweima: require("../static/images/erweima.png"),
    };
  },
  methods: {
    goAbout() {
      goNewHTML("aboutUs");
    },
    goService(indexx) {
      goNewHTML("service", { shouIndex: indexx });
    },
    openBA() {
      window.open("https://beian.miit.gov.cn/", "_blank");
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Footer.vue